/* 🤖 this file was generated by script */
export const wsolidiconUserMinus01 = {
  name: 'user_minus_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M6.79 14.5h4.43l.39.01q.23 0 .57.15A1.5 1.5 0 0 1 13 15.9l.01.39v3.94l-.01.39a1.5 1.5 0 0 1-1.38 1.38l-.39.01q-4.3-.02-8.63 0-.12 0-.35-.02A1.5 1.5 0 0 1 1 20.4c0-.6-.03-1.2.08-1.78a5 5 0 0 1 4.05-4.05 10 10 0 0 1 1.66-.08M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
